






































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {Document} from '@/lib/kepler/interfaces'
import Utils from '@/utils'

import {PopupState} from '@/store'
import AddDocumentView from '@/components/registration/RegistrationDrivingLicenseStep.vue'

@Component({
  name: 'Documents',
  components: {
    FilteredListWithAddButton: Utils.loadComponent('FilteredListWithAddButton'),
    GradientCard: Utils.loadComponent('GradientCard'),
    CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Divider: Utils.loadComponent('proxy/Divider'),
  },
})
export default class Documents extends Vue {
  @State((state) => state.configuration.appConfig.fields_configuration) public fieldConfigState!: any
  @State((state) => state.profile.documents) public documentsState!: Document[]
  public showActiveOnly: boolean = true
  @Prop({}) private documents!: Document[]
  @Action('openPopup') private openPopup!: any

  private get docs() {
    const d = this.documents ? this.documents : this.documentsState
    if (this.showActiveOnly) {
      return d.filter((doc) => {
        return doc.status === 'VALID'
      })
    }
    return d
  }

  private get hasInactiveDocs() {
    return Object.keys(this.docs.filter((doc) => {
      return doc.status === 'VALID'
    })) !== Object.keys(this.docs)
  }

  private created() {
    if (!this.docs.length && this.documentsState.length) {
      this.showActiveOnly = false
    }
  }

  private fieldHidden(field: string) {
    if (!this.fieldConfigState) {
      return false
    }
    const fieldPropsString = Utils.getProp(this.fieldConfigState, field.split('.')) as string || ''
    return fieldPropsString.includes('hidden')
  }

  @Watch('docs', {immediate: true})
  private documentsPresence(val: Document[]) {
    this.$emit('noDocuments', !val.length)
  }

  private addDocument() {
    this.openPopup(
      new PopupState(AddDocumentView, null,
        this.$t('registration.documents')))
  }
}
